export const ADD_CHECK_IN_CALL = gql`
    mutation AddCheckInCall($input: CheckInCallCreateItemInput!) {
        addCheckInCall(input: $input) {
            success
            message
        }
    }
`;

export const UPDATE_CHECK_IN_CALL = gql`
    mutation UpdateCheckInCall($input: CheckInCallUpdateItemInput!) {
        updateCheckInCall(input: $input) {
            success
            message
        }
    }
`;

export const DELETE_CHECK_IN_CALL = gql`
    mutation DeleteCheckInCall($id: Int!) {
        deleteCheckInCall(id: $id) {
            success
            message
        }
    }
`;
